// src/CookieBanner.jsx
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const GA_ID = 'G-YGXG5NEPYH';
const CONSENT_KEY = 'jkl_cookie_consent';

function loadGA() {
  if (window.__gaLoaded) return;
  window.__gaLoaded = true;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID);
}

export default function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (consent === 'accepted') { loadGA(); }
    else if (!consent) { setVisible(true); }
  }, []);

  const accept = () => { localStorage.setItem(CONSENT_KEY, 'accepted'); loadGA(); setVisible(false); };
  const reject = () => { localStorage.setItem(CONSENT_KEY, 'rejected'); setVisible(false); };

  if (!visible) return null;

  return (
    <div style={{position:'fixed',bottom:0,left:0,right:0,zIndex:99999,background:'#12121a',borderTop:'1px solid rgba(212,165,80,0.2)',padding:'16px 24px',display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:'12px',fontFamily:'Inter, sans-serif'}}>
      <p style={{margin:0,fontSize:'13px',color:'#b0adb8',maxWidth:'700px',lineHeight:1.6}}>
        {t('cookie.text')}{' '}
        <a href="/privacy" style={{color:'#d4a550',textDecoration:'underline'}}>{t('cookie.privacy_link')}</a>
      </p>
      <div style={{display:'flex',gap:'10px',flexShrink:0}}>
        <button onClick={reject}
          style={{padding:'8px 18px',background:'transparent',color:'#8a8a9a',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'6px',fontFamily:'Kanit, sans-serif',fontSize:'12px',fontWeight:500,letterSpacing:'0.08em',textTransform:'uppercase',cursor:'pointer'}}
          onMouseEnter={e=>{e.target.style.borderColor='rgba(255,255,255,0.3)';e.target.style.color='#f0ece4';}}
          onMouseLeave={e=>{e.target.style.borderColor='rgba(255,255,255,0.1)';e.target.style.color='#8a8a9a';}}>
          {t('cookie.reject')}
        </button>
        <button onClick={accept}
          style={{padding:'8px 18px',background:'#d4a550',color:'#07070a',border:'none',borderRadius:'6px',fontFamily:'Kanit, sans-serif',fontSize:'12px',fontWeight:700,letterSpacing:'0.08em',textTransform:'uppercase',cursor:'pointer'}}
          onMouseEnter={e=>{e.target.style.background='#f0c878';}}
          onMouseLeave={e=>{e.target.style.background='#d4a550';}}>
          {t('cookie.accept')}
        </button>
      </div>
    </div>
  );
}
